export default __webpack_public_path__ + "static/media/10_garage.3d534ae5.png";